import Cookies from 'js-cookie';

import {CookieVisitorData} from 'standalone/groupCMP/src/types';
import {SESSION_VISITOR_DATA_KEY} from 'standalone/groupCMP/src/utils/constants';

const MAX_TRUE_CATEGORIES_FOR_REJECTED = 1;

export function shouldDelayCmp(): boolean {
    const cookieValue = Cookies.get(SESSION_VISITOR_DATA_KEY);

    if (!cookieValue) {
        return true;
    }

    try {
        const visitorData: CookieVisitorData = JSON.parse(cookieValue);
        const categories = visitorData[1] ?? [];
        const trueCount = categories.filter(([, value]) => value === 'true').length;

        return trueCount <= MAX_TRUE_CATEGORIES_FOR_REJECTED;
    } catch {
        return true;
    }
}
